module.exports = __webpack_public_path__ + "static/media/Bamazon.65fcbdd8.gif";